import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../util";

/* Las pills son la única excepción a las esquinas rectas. */
const variantes = cva(
  "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 font-ui text-xs font-semibold leading-tight",
  {
    variants: {
      tono: {
        neutro: "border-linea-fuerte bg-fondo-suave text-tinta-2",
        tinta: "border-tinta bg-tinta text-tinta-inversa",
        azul: "border-azul/30 bg-azul/10 text-azul",
        verde: "border-verde/30 bg-verde/10 text-verde",
        ambar: "border-ambar/30 bg-ambar/10 text-ambar",
        rojo: "border-rojo/30 bg-rojo/10 text-rojo",
        naranja: "border-naranja bg-naranja text-white",
      },
    },
    defaultVariants: { tono: "neutro" },
  },
);

export interface PillProps
  extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof variantes> {}

export function Pill({ className, tono, ...props }: PillProps) {
  return <span className={cn(variantes({ tono }), className)} {...props} />;
}

/** Semáforo de coord: verde / ámbar / rojo, con punto y texto. */
export function Semaforo({
  color,
  children,
}: {
  color: "verde" | "ambar" | "rojo" | "gris";
  children?: React.ReactNode;
}) {
  const tono = color === "gris" ? "neutro" : color;
  const punto = { verde: "bg-verde", ambar: "bg-ambar", rojo: "bg-rojo", gris: "bg-tinta-tenue" }[
    color
  ];
  return (
    <Pill tono={tono}>
      <span className={cn("size-1.5 rounded-full", punto)} aria-hidden="true" />
      {children}
    </Pill>
  );
}
